import React, { useRef, useState, useEffect } from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import { AlignLeft, AlignCenter, AlignRight } from 'lucide-react';

const ResizableImageNode = (props) => {
  const { node, updateAttributes, selected } = props;
  const imageRef = useRef(null);
  const wrapperRef = useRef(null);
  
  const [isResizing, setIsResizing] = useState(false);
  const [initialWidth, setInitialWidth] = useState(0);
  const [initialMouseX, setInitialMouseX] = useState(0);

  const src = node.attrs.src;
  const alt = node.attrs.alt;
  const width = node.attrs.width || '100%'; // Default to responsive
  const style = node.attrs.style || '';
  const align = node.attrs.align || 'center'; // left, center, right

  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsResizing(true);
    setInitialMouseX(e.clientX);
    
    if (wrapperRef.current) {
      setInitialWidth(wrapperRef.current.offsetWidth);
    }
  };

  const setAlignment = (newAlign) => {
    updateAttributes({ align: newAlign });
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isResizing) return;
      
      const dx = e.clientX - initialMouseX;
      // Calculate new width
      const newWidth = Math.max(100, initialWidth + dx); // Minimum width 100px
      
      updateAttributes({ width: `${newWidth}px` });
    };

    const handleMouseUp = () => {
      setIsResizing(false);
    };

    if (isResizing) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizing, initialMouseX, initialWidth, updateAttributes]);

  let alignClass = 'align-center';
  if (align === 'left') alignClass = 'align-left';
  if (align === 'right') alignClass = 'align-right';

  return (
    <NodeViewWrapper className={`image-resizer-wrapper ${alignClass} ${selected ? 'is-selected' : ''}`}>
      <div 
        ref={wrapperRef}
        className="image-resizer-container"
        style={{ width: width !== '100%' ? width : 'auto', maxWidth: '100%' }}
      >
        <img 
          ref={imageRef}
          src={src} 
          alt={alt} 
          style={{ width: '100%', height: 'auto', display: 'block' }} 
        />
        
        {/* Resize Handle (Bottom Right) */}
        {selected && (
          <div 
            className="resize-handle bottom-right"
            onMouseDown={handleMouseDown}
          ></div>
        )}
        
        {/* Alignment Controls Overlay */}
        {selected && (
          <div className="image-controls-overlay">
            <button type="button" onClick={() => setAlignment('right')} className={align === 'right' ? 'active' : ''} title="محاذاة لليمين">
              <AlignRight size={16} />
            </button>
            <button type="button" onClick={() => setAlignment('center')} className={align === 'center' ? 'active' : ''} title="محاذاة للوسط">
              <AlignCenter size={16} />
            </button>
            <button type="button" onClick={() => setAlignment('left')} className={align === 'left' ? 'active' : ''} title="محاذاة لليسار">
              <AlignLeft size={16} />
            </button>
          </div>
        )}
      </div>
    </NodeViewWrapper>
  );
};

export default ResizableImageNode;
